import { defineStore } from "pinia";

export const useMetaTagsStore = defineStore("metatags", {
	state: () => {
		return {
			page: "home",
			pages: {},
		};
	},
	actions: {
		addPage(page: any, metaTags: any) {
			this.pages[page] = metaTags;
		},
		setPage(page: any) {
			this.page = page;
		},
		removePage(page: any) {
			this.pages[page] = null;
		},
	},
});
